import { createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import {
  setServerNotificationData,
  setStepNotificationData,
  setThirdPartyNotificationData
} from 'redux/store/slices/wsSlice'
import TokenService from 'services/token.service'
import { type SocketNotifications } from 'share/types'

import { baseWsUrl } from '../constants'
import { WebSocketManager } from './web-socket-manager'

const notificationsWs = createAsyncThunk(
  'ws/notifications',
  async ({ iin }: { iin: string | null | undefined }, { dispatch }) => {
    try {
      const token = TokenService.getAccessToken()
      if (!iin || !token) throw new Error('There is not iin or auth.token to open websocket connection.')
      const url = `${baseWsUrl}/ws/notifications/${iin}/?token=${token}`

      const wsManager = new WebSocketManager<SocketNotifications>(url)
      wsManager.checkMessageFn = message => message.type === 'command_processing_result' && message.value === 'pong'
      wsManager.onMessage = (ws, message) => {
        if (
          message.type === 'step_status' ||
          message.type === 'server_notification' ||
          message.type === 'third_party_notifier'
        ) {
          ws.send(
            JSON.stringify({
              type: 'message_ack',
              key: message.key
            })
          )
        }
        if (message.type === 'step_status') {
          dispatch(setStepNotificationData(message))
        } else if (message.type === 'server_notification') {
          dispatch(setServerNotificationData(message.value))
        } else if (message.type === 'third_party_notifier') {
          dispatch(setThirdPartyNotificationData(message))
        }
      }
      await wsManager.connect()
    } catch (err) {
      toast.error('Не получилось открыть WebSocket', {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true
      })
      console.log(err)
    }
  }
)

export default notificationsWs
